import { Typography } from '@mui/material';
import { get } from 'lodash';
import { useMemo } from 'react';

interface Props {
  message?: string;
  error?: unknown;
}

export function ErrorMessage({ message, error }: Props) {
  const errorMessage = useMemo(
    () => message ?? get(error, 'message') ?? 'Oops, something went wrong!',
    [error, message]
  );

  return <Typography color="error">{errorMessage}</Typography>;
}
